/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Following_LabelInputs */

const th_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังติดตาม`)
};

const en_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following`)
};

const ja_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォロー中`)
};

const zh_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注中`)
};

const es_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiendo`)
};

const pt_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguindo`)
};

const id_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

const fr_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivis`)
};

const tl_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinusundan`)
};

const vi_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang theo dõi`)
};

const ko_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔로잉`)
};

const de_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folge ich`)
};

const ru_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписки`)
};

const tr_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip edilenler`)
};

const it_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguiti`)
};

const pl_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwowane`)
};

const uk_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписки`)
};

const hi_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉलो किए गए`)
};

const ar_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتابَعون`)
};

const ms_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

const bn_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুসৃত`)
};

const zh_tw2_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤中`)
};

const zh_hk2_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤中`)
};

const ur_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فالو شدہ`)
};

const fa_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دنبال‌شده`)
};

const sw_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unafuatilia`)
};

const nl_following_label = /** @type {(inputs: Following_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevolgd`)
};

/**
* | output |
* | --- |
* | "Following" |
*
* @param {Following_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const following_label = /** @type {((inputs?: Following_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_following_label(inputs)
	if (locale === "ja") return ja_following_label(inputs)
	if (locale === "zh") return zh_following_label(inputs)
	if (locale === "es") return es_following_label(inputs)
	if (locale === "pt") return pt_following_label(inputs)
	if (locale === "id") return id_following_label(inputs)
	if (locale === "fr") return fr_following_label(inputs)
	if (locale === "tl") return tl_following_label(inputs)
	if (locale === "vi") return vi_following_label(inputs)
	if (locale === "ko") return ko_following_label(inputs)
	if (locale === "de") return de_following_label(inputs)
	if (locale === "ru") return ru_following_label(inputs)
	if (locale === "tr") return tr_following_label(inputs)
	if (locale === "it") return it_following_label(inputs)
	if (locale === "pl") return pl_following_label(inputs)
	if (locale === "uk") return uk_following_label(inputs)
	if (locale === "hi") return hi_following_label(inputs)
	if (locale === "ar") return ar_following_label(inputs)
	if (locale === "ms") return ms_following_label(inputs)
	if (locale === "bn") return bn_following_label(inputs)
	if (locale === "zh-TW") return zh_tw2_following_label(inputs)
	if (locale === "zh-HK") return zh_hk2_following_label(inputs)
	if (locale === "ur") return ur_following_label(inputs)
	if (locale === "fa") return fa_following_label(inputs)
	if (locale === "sw") return sw_following_label(inputs)
	if (locale === "nl") return nl_following_label(inputs)
	return en_following_label(inputs)
});